/* eslint-disable no-nested-ternary, eqeqeq */
import queryString from 'query-string'
import { Base64 } from 'js-base64'

import { AUTH_TYPES, getRegion } from '../../constants'
import {
  getToken,
  renewAuth,
  timeRemainingOnTokenMs,
  checkAuthentication,
} from '../../containers/Auth'
import { generateQueryParam } from '../../containers/Utilities'
import { updateEKGReviewStackNextToken } from '../../pages/EkgReview/module'
import { updateQtEKGReviewStackNextToken } from '../../pages/QtEkgReview/module'
import ApiServiceError from 'state/services/ApiServiceError'
import { setApiServiceError } from '../../store/appReducer'

// eslint-disable-next-line consistent-return
export const getApiBaseUrl = () => {
  let region = getRegion()
  region = region !== '' ? `${region}-` : ''
  return `${process.env.REACT_APP_API_PROTOCOL}://${region}${process.env.REACT_APP_API_DOMAIN}`
}
export const getCrpApiBaseUrl = () => {
  let region = getRegion()
  region = region !== '' ? `.${region}-` : ''
  return `${
    process.env.REACT_APP_API_PROTOCOL
  }://${process.env.REACT_APP_CRP_API_DOMAIN.replace('.{region}.', region)}`
}
export const getGoKardiaApiBaseUrl = () => {
  let region = getRegion()
  region = region !== '' ? `${region}-` : ''
  return `${process.env.REACT_APP_API_PROTOCOL}://${region}${process.env.REACT_APP_GOKARDIA_API_DOMAIN}`
}
export const getKardiaApiBaseUrl = () => {
  let region = getRegion()
  region = region !== '' ? `${region}-` : ''
  return `${process.env.REACT_APP_API_PROTOCOL}://${region}${process.env.REACT_APP_KARDIA_API_DOMAIN}`
}

export const getTeleconnectApiBaseUrl = () => process.env.REACT_APP_TELEKARDIA_DOMAIN

export const fetchApi = ({
  url = '',
  method = 'GET',
  body,
  header = {},
  authType = AUTH_TYPES.NONE,
  credentials = {}, // required for basic auth
}) => (dispatch, getState) => {
  const { browser } = getState().app

  const headers = new Headers(
    Object.assign(
      {},
      {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      header,
    ),
  )

  const { BEARER, BASIC, NONE } = AUTH_TYPES
  let basicToken
  const { username = '', password = '' } = credentials

  switch (authType) {
  case BASIC:
    basicToken = Base64.encode(`${username}:${password}`) || ''
    headers.append('Authorization', `Basic ${basicToken}`)
    break
  case BEARER:
    headers.append('Authorization', `Bearer ${getToken() || ''}`)
    break
  case NONE:
  default:
    break
  }

  if (browser && browser.name === 'ie') {
    headers.append('pragma', 'no-cache')
    headers.append(
      'cache-control',
      'no-cache, no-store, must-revalidate, max-age=0',
    )
  }

  const init = {
    method,
    headers,
    mode: 'cors',
  }

  if (body) {
    init.body = body
  }

  return fetch(url, init)
    .then(res => {
      if (res.status === 401) {
        dispatch(checkAuthentication())
        throw new Error('Unauthorized')
      } else if (res.status === 503) {
        dispatch(
          setApiServiceError({
            status: res.status,
            url,
          }),
        )
      }
      // if (url !== `${getApiBaseUrl()}/i/v1/jwt`) {
      //   // TODO: Potentially need to throttle
      //   if (getState().auth.isAuthenticated
      //     && timeRemainingOnTokenMs() > 0
      //     && timeRemainingOnTokenMs() <= NETWORK_RENEW_AUTH_THRESHOLD_MS) {
      //     dispatch(renewAuth()) // Refresh auth every valid response
      //   }
      // }
      return res
    })
    .catch(err => {
      // eslint-disable-next-line no-console
      console.log(err)
      throw err
    })
}

export const fetchGetJWT = (
  credentials = {
    username: '',
    password: '',
  },
) => (dispatch, getState) => {
  let respStatus = 200
  return dispatch(
    fetchApi({
      url: `${getApiBaseUrl()}/i/v1/jwt`,
      authType: AUTH_TYPES.BASIC,
      credentials,
    }),
  )
    .then(res => {
      respStatus = res.status
      return res
    })
    .then(res => res.json())
    .then(res => {
      if (respStatus === 403) {
        throw new ApiServiceError(403, res)
      }
      return res
    })
    .then(res => res.jwt)
    .catch(err => {
      throw err
    })
}

// AppOrchard JWT fetch
export const fetchGetSSOJWT = (
  credentials = {
    code: '',
    sso: true,
  },
) => (dispatch, getState) => {
  let respStatus = 200
  return dispatch(
    fetchApi({
      url: `${getApiBaseUrl()}/appOrchard/v1/jwt?${queryString.stringify({
        code: credentials.code,
      })}`,
      authType: AUTH_TYPES.BASIC,
      credentials,
    }),
  )
    .then(res => {
      respStatus = res.status
      return res
    })
    .then(res => res.json())
    .then(res => {
      if (respStatus === 403) {
        throw new ApiServiceError(403, res)
      }
      return res
    })
    .then(res => res.jwt)
    .catch(err => {
      throw err
    })
}

export const fetchRenewJWT = () => (dispatch, getState) =>
  dispatch(
    fetchApi({
      url: `${getApiBaseUrl()}/i/v1/jwt`,
      authType: AUTH_TYPES.BEARER,
    }),
  )
    .then(res => res.json())
    .then(res => res.jwt)
    .catch(err => {
      throw err
    })

export const fetchSsoJWT = ({ env, org, team, data }) => (dispatch, getState) =>
  dispatch(
    fetchApi({
      url: `${getApiBaseUrl()}/i/v1/sso/jwt?${queryString.stringify({
        env,
        org,
        team,
        data,
      })}`,
      authType: AUTH_TYPES.NONE,
    }),
  )
    .then(res => res.json())
    .catch(err => {
      throw err
    })

export const XmlHttpRequestSyncDeleteJwt = token =>
  new Promise((resolve, reject) => {
    /* eslint-disable no-undef */
    const request = new XMLHttpRequest()
    const url = `${getApiBaseUrl()}/i/v1/jwt`
    request.open('DELETE', url, false) // `false` makes the request synchronous
    request.setRequestHeader('authorization', `Bearer ${token}`)
    request.send(null)
    resolve()
  })

export const fetchMe = () => (dispatch, getState) =>
  dispatch(
    fetchApi({
      url: `${getApiBaseUrl()}/i/v1/me`,
      authType: AUTH_TYPES.BEARER,
    }),
  )
    .then(res => res.json())
    .catch(err => {
      throw err
    })

export const fetchPrescriptions = teamId => (dispatch, getState) =>
  dispatch(
    fetchApi({
      url: `${getApiBaseUrl()}/i/v1/teams/${teamId}/templates`,
      authType: AUTH_TYPES.BEARER,
    }),
  )
    .then(res => res.json())
    .catch(err => {
      throw err
    })

export const fetchInterpretations = teamId => (dispatch, getState) =>
  dispatch(
    fetchApi({
      url: `${getApiBaseUrl()}/i/v1/teams/${teamId}/interpretations`,
      authType: AUTH_TYPES.BEARER,
    }),
  )
    .then(res => res.json())
    .catch(err => {
      throw err
    })

export const fetchPhysiciansAndEkgStackCount = teamId => (dispatch, getState) =>
  dispatch(
    fetchApi({
      url: `${getApiBaseUrl()}/i/v1/teams/${teamId}/members`,
      authType: AUTH_TYPES.BEARER,
    }),
  )
    .then(res => res.json())
    .catch(err => {
      throw err
    })

export const fetchOrderingProviders = teamId => (dispatch, getState) =>
  dispatch(
    fetchApi({
      url: `${getApiBaseUrl()}/i/v1/teams/${teamId}/kpspTeamInfo`,
      authType: AUTH_TYPES.BEARER,
    }),
  )
    .then(res => res.json())
    .catch(err => {
      throw err
    })

export const fetchPatients = teamId => (dispatch, getState) =>
  dispatch(
    fetchApi({
      url: `${getApiBaseUrl()}/i/v1/teams/${teamId}/participants`,
      authType: AUTH_TYPES.BEARER,
    }),
  )
    .then(res => res.json())
    .catch(err => {
      throw err
    })

export const fetchPatient = patientId => (dispatch, getState) =>
  dispatch(
    fetchApi({
      url: `${getApiBaseUrl()}/i/v1/participants/${patientId}?limit=500`,
      authType: AUTH_TYPES.BEARER,
    }),
  )
    .then(res => res.json())
    .catch(err => {
      throw err
    })

export const fetchAddresses = patientId => (dispatch, getState) =>
  dispatch(
    fetchApi({
      url: `${getApiBaseUrl()}/i/v1/participants/${patientId}/defaultPrimaryAndShippingAddress`,
      authType: AUTH_TYPES.BEARER,
    }),
  )
    .then(res => res.json())
    .catch(err => {
      throw err
    })

export const fetchInsurances = patientId => (dispatch, getState) =>
  dispatch(
    fetchApi({
      url: `${getApiBaseUrl()}/i/v1/participants/${patientId}/defaultPrimaryAndSecondaryInsurance`,
      authType: AUTH_TYPES.BEARER,
    }),
  )
    .then(res => res.json())
    .catch(err => {
      throw err
    })

export const fetchIdtfEnrollments = patientId => (dispatch, getState) =>
  dispatch(
    fetchApi({
      url: `${getApiBaseUrl()}/i/v1/idtf_participants/${patientId}/enrollments`,
      authType: AUTH_TYPES.BEARER,
    }),
  )
    .then(res => res.json())
    .catch(err => {
      throw err
    })

export const fetchEnrollPatientOverview = patientId => (dispatch, getState) =>
  dispatch(
    fetchApi({
      url: `${getApiBaseUrl()}/i/v1/idtf/participants/${patientId}/enrollmentOverview`,
      authType: AUTH_TYPES.BEARER,
    }),
  )
    .then(res => res.json())
    .catch(err => {
      throw err
    })

export const updateAddress = (patientId, addressId, address) => (
  dispatch,
  getState,
) =>
  dispatch(
    fetchApi({
      url: `${getApiBaseUrl()}/i/v1/participants/${patientId}/addresses/${addressId}`,
      authType: AUTH_TYPES.BEARER,
      method: 'PUT',
      body: JSON.stringify(address),
    }),
  )
    .then(res => res.json())
    .catch(err => {
      throw err
    })

export const updateInsurance = (patientId, insuranceId, insurance) => (
  dispatch,
  getState,
) =>
  dispatch(
    fetchApi({
      url: `${getApiBaseUrl()}/i/v1/participants/${patientId}/insurances/${insuranceId}`,
      authType: AUTH_TYPES.BEARER,
      method: 'PUT',
      body: JSON.stringify(insurance),
    }),
  )
    .then(res => res.json())
    .catch(err => {
      throw err
    })

export const fetchPutPatientTriggers = (patientId, triggers) => (
  dispatch,
  getState,
) =>
  dispatch(
    fetchApi({
      url: `${getApiBaseUrl()}/i/v1/participants/${patientId}/triggers`,
      authType: AUTH_TYPES.BEARER,
      method: 'PUT',
      body: JSON.stringify(triggers),
    }),
  )
    .then(res => res.json())
    .catch(err => {
      throw err
    })

export const fetchPatientTriggers = patientId => (dispatch, getState) =>
  dispatch(
    fetchApi({
      url: `${getApiBaseUrl()}/i/v1/participants/${patientId}/triggers`,
      authType: AUTH_TYPES.BEARER,
    }),
  )
    .then(res => res.json())
    .catch(err => {
      throw err
    })

export const fetchPutPatient = (patientId, patient) => (dispatch, getState) =>
  dispatch(
    fetchApi({
      url: `${getApiBaseUrl()}/i/v1/participants/${patientId}/profile`,
      authType: AUTH_TYPES.BEARER,
      method: 'PUT',
      body: JSON.stringify(patient),
    }),
  )
    // .then(res => res.json())
    .catch(err => {
      throw err
    })

export const fetchPostPatient = (teamId, patient) => (dispatch, getState) =>
  dispatch(
    fetchApi({
      url: `${getApiBaseUrl()}/i/v1/teams/${teamId}/participants`,
      authType: AUTH_TYPES.BEARER,
      method: 'POST',
      body: JSON.stringify(patient),
    }),
  )
    // .then(res => res.json())
    .catch(err => {
      throw err
    })

export const fetchMedantaUHID = UHID => (dispatch, getState) =>
  dispatch(
    fetchApi({
      url: `${getApiBaseUrl()}/rp/v1/medanta/api/Patient/GetPatientBasicInformation`,
      authType: AUTH_TYPES.BEARER,
      header: {
        MedUHID: UHID,
      },
    }),
  )
    .then(res => res.json())
    .catch(err => {
      throw err
    })

export const fetchOverview = teamId => (dispatch, getState) =>
  dispatch(
    fetchApi({
      url: `${getApiBaseUrl()}/i/v1/teams/${teamId}/overview`,
      authType: AUTH_TYPES.BEARER,
    }),
  )
    .then(res => res.json())
    .catch(err => {
      throw err
    })

export const fetchActivity = (teamId, startDate, endDate) => (
  dispatch,
  getState,
) => {
  let getQueryParams = ''
  if (startDate) {
    const uriEncodedStartTime = generateQueryParam('startTime', startDate)
    getQueryParams = `?${uriEncodedStartTime}`
  }

  if (endDate) {
    const uriEncodedEndTime = generateQueryParam('endTime', endDate)
    getQueryParams =
      getQueryParams.length === 0
        ? `?${uriEncodedEndTime}`
        : `${getQueryParams}&${uriEncodedEndTime}`
  }

  return dispatch(
    fetchApi({
      url: `${getApiBaseUrl()}/i/v1/teams/${teamId}/activity${getQueryParams}`,
      authType: AUTH_TYPES.BEARER,
    }),
  )
    .then(res => res.json())
    .catch(err => {
      throw err
    })
}

export const fetchTeamTriggers = teamId => (dispatch, getState) =>
  dispatch(
    fetchApi({
      url: `${getApiBaseUrl()}/i/v1/teams/${teamId}/triggers`,
      authType: AUTH_TYPES.BEARER,
    }),
  )
    .then(res => res.json())
    .catch(err => {
      throw err
    })

export const fetchPutTeamTriggers = (teamId, triggers) => (
  dispatch,
  getState,
) =>
  dispatch(
    fetchApi({
      url: `${getApiBaseUrl()}/i/v1/teams/${teamId}/triggers`,
      authType: AUTH_TYPES.BEARER,
      method: 'PUT',
      body: JSON.stringify(triggers),
    }),
  )
    .then(res => res.json())
    .catch(err => {
      throw err
    })

export const fetchPatientsIdtf = (
  teamId,
  identifier,
  identifierCheck,
  pageLimt,
  page,
) => (dispatch, getState) => {
  // page=1&identifier=Test&mrn=Testing1010
  const identifierValue = identifier
  // const identifierValue = identifier && identifier.split(':')[1]
  const checkIdentifier = identifierValue
    ? `/idtf?${identifierCheck}=${encodeURIComponent(
      identifierValue,
    )}&pageLimit=${pageLimt}&page=${page}`
    : `/idtf?pageLimit=${pageLimt}&page=${page}`
  return dispatch(
    fetchApi({
      url: `${getApiBaseUrl()}/i/v1/teams/${teamId}/participants${checkIdentifier}`,
      authType: AUTH_TYPES.BEARER,
    }),
  )
    .then(res => res.json())
    .catch(err => {
      throw err
    })
}

export const fetchPatientAutoCompleteIdtf = teamId => (dispatch, getState) =>
  dispatch(
    fetchApi({
      url: `${getApiBaseUrl()}/i/v1/idtf/teams/${teamId}/participants/autocomplete`,
      authType: AUTH_TYPES.BEARER,
    }),
  )
    .then(res => res.json())
    .catch(err => {
      throw err
    })

export const fetchPatientsCCT = (
  teamId,
  pageLimit,
  page,
  identifier,
  practiceID,
  orderingPhysicianID,
  queryKeyword,
) => (dispatch, getState) => {
  const identifierValueMrn = identifier
  // const identifierValueMrn = identifier && identifier.split(':')[1]
  const identifierEndpoint = identifierValueMrn
    ? `idtf?pageLimit=${pageLimit}&page=${page}&${queryKeyword}=${encodeURIComponent(
      identifierValueMrn,
    )}&practiceID=${practiceID}&orderingPhysicianID=${orderingPhysicianID}`
    : `idtf?pageLimit=${pageLimit}&page=${page}&practiceID=${practiceID}&orderingPhysicianID=${orderingPhysicianID}`
  return dispatch(
    fetchApi({
      url: `${getApiBaseUrl()}/i/v1/teams/${teamId}/participants/${identifierEndpoint}`,
      authType: AUTH_TYPES.BEARER,
    }),
  )
    .then(res => res.json())
    .catch(err => {
      throw err
    })
}


// Notification Remainders
export const notificationRemaindersRequest = (patientId, data, method) => (
  dispatch,
  getState,
) =>
  dispatch(
    fetchApi({
      url:
        method === 'PUT'
          ? `${getApiBaseUrl()}/i/v1/participants/${patientId}/notificationConfig/${
              data.id
            }`
          : `${getApiBaseUrl()}/i/v1/participants/${patientId}/notificationConfig`,
      authType: AUTH_TYPES.BEARER,
      method,
      body: JSON.stringify(data),
    }),
  )
    .then(res => res.json())
    .catch(err => {
      throw err
    })

export const fetchKardiaRxIdtfEcg = connectionTemplateID => (
  dispatch,
  getState,
) =>
  dispatch(
    fetchApi({
      url: `${getApiBaseUrl()}/i/v1/idtf_participants/connections/${connectionTemplateID}/recordings`,
      authType: AUTH_TYPES.BEARER,
    }),
  )
    .then(res => res.json())
    .catch(err => {
      throw err
    })

export const cctResendEosReport = connectionTemplateID => (dispatch, getState) =>
  dispatch(fetchApi({
    url: `${getApiBaseUrl()}/i/v2/idtfConnections/${connectionTemplateID}/regenerateEosReport`,
    authType: AUTH_TYPES.BEARER,
    method: 'PUT',
  }))
    .then(res => res.json())
    .catch(err => {
      throw err
    })

export const cctCompletedCheckboxPatientDrawer = connectionTemplateID => (dispatch, getState) =>
  dispatch(fetchApi({
    url: `${getApiBaseUrl()}/i/v1/idtf_participants/connections/${connectionTemplateID}/recordings`,
    authType: AUTH_TYPES.BEARER,
  }))
    .then(res => res.json())
    .catch(err => {
      throw err
    })

export const postKardiaRxIdtfEcgConfirm = selectedRecordingId => (dispatch, getState) =>
  dispatch(fetchApi({
    url: `${getApiBaseUrl()}/i/v1/recordings/idtf/${selectedRecordingId}/confirm`,
    authType: AUTH_TYPES.BEARER,
    method: 'PUT',
  }))
    .then(res => res.json())
    .catch(err => {
      throw err
    })

export const postNotificationTeamSettings = (teamId, userId, data) => (
  dispatch,
  getState,
) => {
  dispatch(
    fetchApi({
      url: `${getTeleconnectApiBaseUrl()}/api/v1/teams/${teamId}/admin/${userId}/notification-settings`,
      authType: AUTH_TYPES.BEARER,
      method: 'POST',
      body: JSON.stringify(data),
    }),
  ).catch(err => {
    throw err
  })
}

export const fetchNotificationTeamSettings = (teamId, userId) => (
  dispatch,
  getState,
) =>
  dispatch(
    fetchApi({
      url: `${getTeleconnectApiBaseUrl()}/api/v1/teams/${teamId}/admin/${userId}/notification-settings`,
      authType: AUTH_TYPES.BEARER,
      method: 'GET',
    }),
  )
    .then(res => res.json())
    .catch(err => {
      throw err
    })

export const postBusinessHoursTeamSettings = (
  teamId,
  userId,
  multiple = false,
  data,
  post = true,
  id = null,
  del = false,
) => (dispatch, getState) => {
  const API_URL = `/api/v1/teams/${teamId}/admin/${userId}/businessHour`
  let URL
  if (!post || del) {
    URL = `${API_URL}/${id}`
  } else {
    URL = multiple ? `${API_URL}/multiple` : API_URL
  }

  dispatch(
    fetchApi({
      url: `${getTeleconnectApiBaseUrl()}${URL}`,
      authType: AUTH_TYPES.BEARER,
      method: del ? 'DELETE' : post ? 'POST' : 'PUT',
      body: JSON.stringify(data),
    }),
  ).catch(err => {
    throw err
  })
}

export const fetchBusinessHoursTeamSettings = (teamId, userId) => (
  dispatch,
  getState,
) =>
  dispatch(
    fetchApi({
      url: `${getTeleconnectApiBaseUrl()}/api/v1/teams/${teamId}/admin/${userId}/businessHour`,
      authType: AUTH_TYPES.BEARER,
      method: 'GET',
    }),
  )
    .then(res => res.json())
    .catch(err => {
      throw err
    })

export const fetchWorkListCCT = (
  teamId,
  dropDownValue,
  pageLimit,
  page,
  paginationToken,
  identifier,
  practiceID,
  orderingPhysicianID,
) => (dispatch, getState) => {
  const identifierValue = identifier
  // const identifierValue = identifier && identifier.split(':')[1]
  const checkIdentifier = identifierValue
    ? `stack?inbox=${dropDownValue}&pageLimit=${pageLimit}&page=${page}&startToken=${paginationToken}&identifier=${encodeURIComponent(
      identifierValue,
    )}&teamID=${practiceID}&orderingPhysicianID=${orderingPhysicianID}`
    : `stack?inbox=${dropDownValue}&pageLimit=${pageLimit}&startToken=${paginationToken}&teamID=${practiceID}&orderingPhysicianID=${orderingPhysicianID}`
  return dispatch(
    fetchApi({
      url: `${getApiBaseUrl()}/i/v1/idtf/teams/${teamId}/${checkIdentifier}`,
      authType: AUTH_TYPES.BEARER,
    }),
  )
    .then(res => {
      // console.log('dataList', res.headers.get('X-Continuation-Token'))
      const dataList = res.json()
      // console.log('dataList', dataList)
      const data = {
        dataList,
        token: res.headers.get('X-Continuation-Token'),
      }
      return data
    })
    .catch(err => {
      throw err
    })
}

export const fetchWorkListCCTFilterDropdown = teamId => (dispatch, getState) =>
  dispatch(
    fetchApi({
      url: `${getApiBaseUrl()}/i/v1/annotationInboxes`,
      authType: AUTH_TYPES.BEARER,
    }),
  )
    .then(res => res.json())
    .catch(err => {
      throw err
    })

export const fetchBaseRhythmDropdown = () => (dispatch, getState) =>
  dispatch(
    fetchApi({
      url: `${getApiBaseUrl()}/i/v1/annotationInterpretations`,
      authType: AUTH_TYPES.BEARER,
      method: 'GET',
    }),
  )
    .then(res => res.json())
    .then(payload => dispatch({ type: 'ANNOTATOR.FETCH_BASE_RHYTHM', payload }))
    .catch(err => {
      throw err
    })

export const fetchCCTAnotator = recordingId => (dispatch, getState) =>
  dispatch(
    fetchApi({
      url: `${getApiBaseUrl()}/i/v1/recordings/${recordingId}/annotations`,
      authType: AUTH_TYPES.BEARER,
      method: 'GET',
    }),
  )
    .then(res => res.json())
    .then(payload =>
      dispatch({ type: 'ANNOTATOR.FETCH_RECORDING_INFO', payload }),)
    .catch(err => {
      throw err
    })

export const submitCCTAnotator = (recordingId, payload) => (
  dispatch,
  getState,
) =>
  dispatch(
    fetchApi({
      url: `${getApiBaseUrl()}/i/v1/recordings/${recordingId}/annotations`,
      authType: AUTH_TYPES.BEARER,
      body: JSON.stringify(payload),
      method: 'PUT',
    }),
  )
    .then(res => res.json())
    .then(data =>
      dispatch({ type: 'ANNOTATOR.SUBMIT_COMPLETED', payload: data }),)
    .catch(err => {
      throw err
    })

export const fetchEkgRecording = recordingId => (dispatch, getState) =>
  dispatch(
    fetchApi({
      url: `${getApiBaseUrl()}/i/v1/recordings/${recordingId}`,
      authType: AUTH_TYPES.BEARER,
    }),
  )
    .then(res => res.json())
    .catch(err => {
      throw err
    })

export const fetchEkgRecordingSamples = recordingId => (dispatch, getState) =>
  dispatch(
    fetchApi({
      url: `${getApiBaseUrl()}/i/v1/recordings/${recordingId}/samples`,
      authType: AUTH_TYPES.BEARER,
    }),
  )
    .then(res => res.json())
    .catch(err => {
      throw err
    })

export const fetchEkgRecordingRelated = recordingId => (dispatch, getState) =>
  dispatch(
    fetchApi({
      url: `${getApiBaseUrl()}/i/v1/recordings/${recordingId}/related`,
      authType: AUTH_TYPES.BEARER,
    }),
  )
    .then(res => res.json())
    .catch(err => {
      throw err
    })

export const fetchDeleteEkgRecording = (teamId, recordingId) => (
  dispatch,
  getState,
) =>
  dispatch(
    fetchApi({
      url: `${getApiBaseUrl()}/i/v1/teams/${teamId}/items/${recordingId}`,
      authType: AUTH_TYPES.BEARER,
      method: 'DELETE',
    }),
  )
    .then(res => res.json())
    .catch(err => {
      throw err
    })

export const fetchConfirmEkgRecording = interpretationId => (
  dispatch,
  getState,
) =>
  dispatch(
    fetchApi({
      url: `${getApiBaseUrl()}/i/v1/interpretations/${interpretationId}/confirm`,
      authType: AUTH_TYPES.BEARER,
      method: 'POST',
    }),
  )
    // .then(res => res.json())
    .catch(err => {
      throw err
    })

export const postVendorSpecificInterpretationRecording = (
  interpretationsData,
  venderInterpretationsData,
  callMethod,
  interpretationId,
) => (dispatch, getState) => {
  const urlString =
    callMethod === 'POST'
      ? `/i/v1/recordings/${interpretationsData.recordingID}/vendorSpecificInterpretations`
      : `/i/v1/recordings/${interpretationsData.recordingID}/vendorSpecificInterpretations/${interpretationId}`

  return (
    dispatch(
      fetchApi({
        url: `${getApiBaseUrl()}${urlString}`,
        authType: AUTH_TYPES.BEARER,
        method: callMethod,
        body: JSON.stringify(venderInterpretationsData),
      }),
    )
      // .then(res => res.json())
      .catch(err => {
        throw err
      })
  )
}

export const fetchVendorSpecificInterpretationRecording = (
  recordingId,
  team_id,
) => (dispatch, getState) =>
  dispatch(
    fetchApi({
      url: `${getApiBaseUrl()}/i/v1/recordings/${recordingId}/vendorSpecificInterpretations?teamId=${team_id}`,
      authType: AUTH_TYPES.BEARER,
    }),
  )
    .then(res => res.json())
    .catch(err => {
      throw err
    })

export const fetchInterpretEkgRecording = interpretationsData => (
  dispatch,
  getState,
) =>
  dispatch(
    fetchApi({
      url: `${getApiBaseUrl()}/i/v1/recordings/${
        interpretationsData.recordingID
      }/interpretations`,
      authType: AUTH_TYPES.BEARER,
      method: 'POST',
      body: JSON.stringify(interpretationsData),
    }),
  )
    // .then(res => res.json())
    .catch(err => {
      throw err
    })

export const fetchReassignEkgRecording = (recordingId, assignmentData) => (
  dispatch,
  getState,
) =>
  dispatch(
    fetchApi({
      url: `${getApiBaseUrl()}/i/v1/recordings/${recordingId}/assignment`,
      authType: AUTH_TYPES.BEARER,
      method: 'PUT',
      body: JSON.stringify(assignmentData),
    }),
  )
    // .then(res => res.json())
    .catch(err => {
      throw err
    })

export const fetchEkgReviewStack = (teamId, memberId = null, options) => (
  dispatch,
  getState,
) => {
  let getQueryParams = ''
  const { confirmed, startTime, endTime, nextToken } = options

  if (memberId) {
    const uriEncodedMemberId = generateQueryParam('memberID', memberId)
    getQueryParams = `?${uriEncodedMemberId}`
  }

  if (confirmed) {
    // pageLimit is defaulted to 100 in Backed when not passed in call
    const paginationParams = 'pageLimit=1000&paginated=true'
    const uriEncodedConfirmed = generateQueryParam('confirmed', confirmed)
    getQueryParams =
      getQueryParams.length === 0
        ? `?${uriEncodedConfirmed}&${paginationParams}`
        : `${getQueryParams}&${uriEncodedConfirmed}&${paginationParams}`
  }

  if (startTime) {
    const uriEncodedStartTime = generateQueryParam('startTime', startTime)
    getQueryParams =
      getQueryParams.length === 0
        ? `?${uriEncodedStartTime}`
        : `${getQueryParams}&${uriEncodedStartTime}`
  }

  if (endTime) {
    const uriEncodedEndTime = generateQueryParam('endTime', endTime)
    getQueryParams =
      getQueryParams.length === 0
        ? `?${uriEncodedEndTime}`
        : `${getQueryParams}&${uriEncodedEndTime}`
  }

  if (!confirmed && memberId === null) {
    const paginationParams = 'pageLimit=1000&paginated=true'
    getQueryParams =
      getQueryParams === ''
        ? `?${paginationParams}`
        : `${getQueryParams}&${paginationParams}`
    if (nextToken) {
      getQueryParams = `${getQueryParams}&startToken=${nextToken.token}`
    }
  }

  return dispatch(
    fetchApi({
      url: `${getApiBaseUrl()}/i/v1/teams/${teamId}/stack${getQueryParams}`,
      authType: AUTH_TYPES.BEARER,
    }),
  )
    .then(res => {
      const token = res.headers.get('X-Continuation-Token')
      dispatch(
        updateEKGReviewStackNextToken(token || null, {
          endTime,
          startTime,
          confirmed,
          memberId,
        }),
      )
      return res.json()
    })
    .catch(err => {
      throw err
    })
}

export const fetchQtEkgReviewStack = (teamId, memberId = null, options) => (
  dispatch,
  getState,
) => {
  let getQueryParams = ''
  const {
    confirmed,
    startTime,
    endTime,
    nextToken,
    kpspPracticeTeamId,
  } = options
  if (memberId) {
    const uriEncodedMemberId = generateQueryParam('memberID', memberId)
    getQueryParams = `?${uriEncodedMemberId}`
  }

  if (kpspPracticeTeamId) {
    const uriEncodedMemberId = generateQueryParam('teamID', kpspPracticeTeamId)
    getQueryParams = `?${uriEncodedMemberId}`
  }

  if (confirmed) {
    const uriEncodedConfirmed = generateQueryParam('analysisComplete', confirmed)
    getQueryParams = getQueryParams.length === 0 ? `?${uriEncodedConfirmed}` : `${getQueryParams}&${uriEncodedConfirmed}`
  }

  if (startTime) {
    const uriEncodedStartTime = generateQueryParam('startTime', startTime)
    getQueryParams =
      getQueryParams.length === 0
        ? `?${uriEncodedStartTime}`
        : `${getQueryParams}&${uriEncodedStartTime}`
  }

  if (endTime) {
    const uriEncodedEndTime = generateQueryParam('endTime', endTime)
    getQueryParams =
      getQueryParams.length === 0
        ? `?${uriEncodedEndTime}`
        : `${getQueryParams}&${uriEncodedEndTime}`
  }

  if (!confirmed && memberId === null) {
    const paginationParams = 'pageLimit=1000&paginated=true'
    getQueryParams =
      getQueryParams === ''
        ? `?${paginationParams}`
        : `${getQueryParams}&${paginationParams}`
    if (nextToken) {
      getQueryParams = `${getQueryParams}&startToken=${nextToken.token}`
    }
  }

  return dispatch(
    fetchApi({
      url: `${getApiBaseUrl()}/i/v1/teams/${teamId}/qtRequestRecordings${getQueryParams}`,
      authType: AUTH_TYPES.BEARER,
    }),
  )
    .then(res => {
      const token = res.headers.get('X-Continuation-Token')
      dispatch(
        updateQtEKGReviewStackNextToken(token || null, {
          endTime,
          startTime,
          confirmed,
          memberId,
        }),
      )
      return res.json()
    })
    .catch(err => {
      throw err
    })
}

export const fetchPostEkgReviewStackRemove = (teamId, ekgIds) => (
  dispatch,
  getState,
) =>
  dispatch(
    fetchApi({
      url: `${getApiBaseUrl()}/i/v1/teams/${teamId}/stack/remove`,
      authType: AUTH_TYPES.BEARER,
      method: 'POST',
      body: JSON.stringify(ekgIds),
    }),
  )
    // .then(res => res.json())
    .catch(err => {
      throw err
    })

export const fetchPostResetPassword = email => (dispatch, getState) =>
  dispatch(
    fetchApi({
      url: `${getApiBaseUrl()}/i/v1/reset_password`,
      method: 'POST',
      body: JSON.stringify(email),
    }),
  )
    // .then(res => res.json())
    .catch(err => {
      throw err
    })

export const fetchPostResetPasswordToken = (token, password) => (
  dispatch,
  getState,
) =>
  dispatch(
    fetchApi({
      url: `${getApiBaseUrl()}/i/v1/reset_password/${token}`,
      method: 'POST',
      body: JSON.stringify(password),
    }),
  )
    // .then(res => res.json())
    .catch(err => {
      throw err
    })

export const fetchPatientReports = patientId => (dispatch, getState) =>
  dispatch(
    fetchApi({
      url: `${getApiBaseUrl()}/i/v1/participants/${patientId}/reports`,
      authType: AUTH_TYPES.BEARER,
    }),
  )
    .then(res => res.json())
    .catch(err => {
      throw err
    })

export const fetchPatientNotifications = patientId => (dispatch, getState) =>
  dispatch(
    fetchApi({
      url: `${getApiBaseUrl()}/i/v1/participants/${patientId}/notificationConfigs`,
      authType: AUTH_TYPES.BEARER,
    }),
  )
    .then(res => res.json())
    .catch(err => {
      throw err
    })

export const fetchTeamReports = teamId => (dispatch, getState) =>
  dispatch(
    fetchApi({
      url: `${getApiBaseUrl()}/i/v1/teams/${teamId}/reports`,
      authType: AUTH_TYPES.BEARER,
    }),
  )
    .then(res => res.json())
    .catch(err => {
      throw err
    })

export const fetchPostTeamMemberInvite = (teamId, newTeamMember) => (
  dispatch,
  getState,
) =>
  dispatch(
    fetchApi({
      url: `${getApiBaseUrl()}/i/v1/teams/${teamId}/invites`,
      authType: AUTH_TYPES.BEARER,
      method: 'POST',
      body: JSON.stringify(newTeamMember),
    }),
  )
    // .then(res => res.json())
    .catch(err => {
      throw err
    })

export const fetchPostAcceptTeamMember = newTeamMember => (
  dispatch,
  getState,
) =>
  dispatch(
    fetchApi({
      url: `${getApiBaseUrl()}/i/v1/members`,
      authType: AUTH_TYPES.NONE,
      method: 'POST',
      body: JSON.stringify(newTeamMember),
    }),
  )
    .then(res => res.json())
    .catch(err => {
      throw err
    })

export const fetchDeleteTeamMemberInvite = inviteId => (dispatch, getState) =>
  dispatch(
    fetchApi({
      url: `${getApiBaseUrl()}/i/v1/invites/${inviteId}`,
      authType: AUTH_TYPES.BEARER,
      method: 'DELETE',
    }),
  )
    // .then(res => res.json())
    .catch(err => {
      throw err
    })

export const fetchGetTeamMemberInvites = teamId => (dispatch, getState) =>
  dispatch(
    fetchApi({
      url: `${getApiBaseUrl()}/i/v1/teams/${teamId}/invites`,
      authType: AUTH_TYPES.BEARER,
    }),
  )
    .then(res => res.json())
    .catch(err => {
      throw err
    })

export const fetchGetTeamMember = (teamId, teamMemberId) => (
  dispatch,
  getState,
) =>
  dispatch(
    fetchApi({
      url: `${getApiBaseUrl()}/i/v1/teams/${teamId}/members/${teamMemberId}`,
      authType: AUTH_TYPES.BEARER,
    }),
  )
    .then(res => res.json())
    .catch(err => {
      throw err
    })

export const fetchPutTeamMember = (teamId, teamMemberId, teamMember) => (
  dispatch,
  getState,
) =>
  dispatch(
    fetchApi({
      url: `${getApiBaseUrl()}/i/v1/teams/${teamId}/members/${teamMemberId}`,
      authType: AUTH_TYPES.BEARER,
      method: 'PUT',
      body: JSON.stringify(teamMember),
    }),
  )
    .then(res => res.json())
    .catch(err => {
      throw err
    })

export const fetchPutTeamMemberInfo = (teamId, teamMemberId, teamMember) => (
  dispatch,
  getState,
) =>
  dispatch(
    fetchApi({
      url: `${getApiBaseUrl()}/i/v2/teams/${teamId}/members/${teamMemberId}`,
      authType: AUTH_TYPES.BEARER,
      method: 'PUT',
      body: JSON.stringify(teamMember),
    }),
  )
    .then(res => res.json())
    .catch(err => {
      throw err
    })

export const fetchDeleteTeamMember = (teamId, teamMemberId) => (
  dispatch,
  getState,
) =>
  dispatch(
    fetchApi({
      url: `${getApiBaseUrl()}/i/v1/teams/${teamId}/members/${teamMemberId}`,
      authType: AUTH_TYPES.BEARER,
      method: 'DELETE',
    }),
  )
    .then(res => res.json())
    .catch(err => {
      throw err
    })

export const fetchGetTeamMemberReminders = (teamId, teamMemberId) => (
  dispatch,
  getState,
) =>
  dispatch(
    fetchApi({
      url: `${getApiBaseUrl()}/i/v1/teams/${teamId}/members/${teamMemberId}/reminders`,
      authType: AUTH_TYPES.BEARER,
    }),
  )
    .then(res => res.json())
    .catch(err => {
      throw err
    })

export const fetchPutTeamMemberReminders = (
  teamId,
  teamMemberId,
  reminders,
) => (dispatch, getState) =>
  dispatch(
    fetchApi({
      url: `${getApiBaseUrl()}/i/v1/teams/${teamId}/members/${teamMemberId}/reminders`,
      authType: AUTH_TYPES.BEARER,
      method: 'PUT',
      body: JSON.stringify(reminders),
    }),
  )
    .then(res => res.json())
    .catch(err => {
      throw err
    })

export const fetchPutUpdateReports = reports => (dispatch, getState) =>
  dispatch(
    fetchApi({
      url: `${getApiBaseUrl()}/i/v1/reports`,
      authType: AUTH_TYPES.BEARER,
      method: 'PUT',
      body: JSON.stringify(reports),
    }),
  )
    .then(res => res.json())
    .catch(err => {
      throw err
    })

export const fetchPostPatientDisconnect = patientId => (dispatch, getState) =>
  dispatch(
    fetchApi({
      url: `${getApiBaseUrl()}/i/v1/participants/${patientId}/disconnect`,
      authType: AUTH_TYPES.BEARER,
      method: 'POST',
    }),
  )
    // .then(res => res.json())
    .catch(err => {
      throw err
    })

export const fetchPostPatientRevoke = (patientId, code) => (
  dispatch,
  getState,
) =>
  dispatch(
    fetchApi({
      url: `${getApiBaseUrl()}/i/v1/participants/${patientId}/code/${code}/revoke`,
      authType: AUTH_TYPES.BEARER,
      method: 'POST',
    }),
  )
    // .then(res => res.json())
    .catch(err => {
      throw err
    })

export const fetchGetCustomReportPdf = (patientId, endDate, startDate) => (
  dispatch,
  getState,
) => {
  let getQueryParams = `?countryCode=${getRegion()}`
  const uriEncodedStartTime = generateQueryParam('startTime', startDate)
  getQueryParams =
    getQueryParams.length === 0
      ? `?${uriEncodedStartTime}`
      : `${getQueryParams}&${uriEncodedStartTime}`
  const uriEncodedEndTime = generateQueryParam('endTime', endDate)
  getQueryParams =
    getQueryParams.length === 0
      ? `?${uriEncodedEndTime}`
      : `${getQueryParams}&${uriEncodedEndTime}`

  return dispatch(
    fetchApi({
      url: `${getApiBaseUrl()}/i/v1/participants/${patientId}/summary${getQueryParams}`,
      authType: AUTH_TYPES.BEARER,
      header: {
        Accept: 'application/pdf',
      },
    }),
  )
    .then(res => res.blob())
    .catch(err => {
      throw err
    })
}

export const fetchGetSingleEkgPdf = ekgId => (dispatch, getState) => {
  const getQueryParams = `?countryCode=${getRegion()}`

  return (
    dispatch(
      fetchApi({
        url: `${getApiBaseUrl()}/i/v1/recordings/${ekgId}.pdf${getQueryParams}`,
        authType: AUTH_TYPES.BEARER,
        header: {
          Accept: 'application/pdf',
        },
      }),
    )
      // .then(res => res.json())
      .then(res => res.blob())
      .catch(err => {
        throw err
      })
  )
}

export const fetchGetSingleReportPdf = reportId => (dispatch, getState) => {
  const getQueryParams = `?countryCode=${getRegion()}`

  return (
    dispatch(
      fetchApi({
        url: `${getApiBaseUrl()}/i/v1/reports/${reportId}/pdf${getQueryParams}`,
        authType: AUTH_TYPES.BEARER,
        header: {
          Accept: 'application/pdf',
        },
      }),
    )
      // .then(res => res.json())
      .then(res => res.blob())
      .catch(err => {
        throw err
      })
  )
}

export const fetchGetSingleReport = reportId => (dispatch, getState) =>
  dispatch(
    fetchApi({
      url: `${getApiBaseUrl()}/i/v1/reports/${reportId}`,
      authType: AUTH_TYPES.BEARER,
    }),
  )
    .then(res => res.json())
    .catch(err => {
      throw err
    })

export const fetchPostReportsEmailExport = (teamId, reportIds) => (
  dispatch,
  getState,
) =>
  dispatch(
    fetchApi({
      url: `${getApiBaseUrl()}/i/v1/teams/${teamId}/reports`,
      authType: AUTH_TYPES.BEARER,
      method: 'POST',
      body: JSON.stringify(reportIds),
    }),
  )
    // .then(res => res.json())
    .catch(err => {
      throw err
    })

export const fetchPostEkgsEmailExport = (teamId, ekgIds) => (
  dispatch,
  getState,
) => {
  const getQueryParams = `?countryCode=${getRegion()}`

  return (
    dispatch(
      fetchApi({
        url: `${getApiBaseUrl()}/i/v1/teams/${teamId}/ekg_exports${getQueryParams}`,
        authType: AUTH_TYPES.BEARER,
        method: 'POST',
        body: JSON.stringify(ekgIds),
      }),
    )
      // .then(res => res.json())
      .catch(err => {
        throw err
      })
  )
}

export const fetchGetExportsUrl = exportId => (dispatch, getState) =>
  dispatch(
    fetchApi({
      url: `${getApiBaseUrl()}/i/v1/exports/${exportId}`,
      authType: AUTH_TYPES.BEARER,
    }),
  )
    .then(res => res.json())
    .catch(err => {
      throw err
    })

export const fetchPostPassword = password => (dispatch, getState) =>
  dispatch(
    fetchApi({
      url: `${getApiBaseUrl()}/i/v1/password`,
      authType: AUTH_TYPES.BEARER,
      method: 'POST',
      body: JSON.stringify(password),
    }),
  ).catch(err => {
    throw err
  })

export const submitStarStatusUpdate = recordingId => (dispatch, getState) =>
  dispatch(
    fetchApi({
      url: `${getApiBaseUrl()}/i/v1/recordings/${recordingId}/toggleHighlightStrip`,
      authType: AUTH_TYPES.BEARER,
      method: 'PATCH',
    }),
  )
    .then(res => res.json())
    .catch(err => {
      throw err
    })

export const fetchAppointmentNotification = (teamId, memeberId) => (
  dispatch,
  getState,
) =>
  dispatch(
    fetchApi({
      url: `${getTeleconnectApiBaseUrl()}/api/v1/teams/${teamId}/member/${memeberId}/settings/notification`,
      authType: AUTH_TYPES.BEARER,
    }),
  )
    .then(res => res.json())
    .catch(err => {
      throw err
    })

export const getEosStatus = recordingId => (dispatch, getState) =>
  dispatch(fetchApi({
    url: `${getApiBaseUrl()}/i/v2/idtfConnections/${recordingId}/eosReportStatus`,
    authType: AUTH_TYPES.BEARER,
    method: 'GET',
  }))
    .then(res => res.json())
    .catch(err => {
      throw err
    })

export const fetchPostAppointmentNotification = (teamId, memeberId, data) => (
  dispatch,
  getState,
) =>
  dispatch(
    fetchApi({
      url: `${getTeleconnectApiBaseUrl()}/api/v1/teams/${teamId}/member/${memeberId}/settings/notification`,
      authType: AUTH_TYPES.BEARER,
      method: 'POST',
      body: JSON.stringify(data),
    }),
  ).catch(err => {
    throw err
  })

export const getFetchEosReport = recordingId => (dispatch, getState) =>
  dispatch(
    fetchApi({
      url: `${getApiBaseUrl()}/i/v1/idtfConnections/${recordingId}/eosReport`,
      authType: AUTH_TYPES.BEARER,
      header: {
        Accept: 'application/pdf',
      },
      method: 'GET',
    }),
  )
    .then(res => {
      if (res.status != 500) {
        return res.blob()
      } else {
        return res.json()
      }
    })
    .catch(err => {
      throw err
    })

export const getEKGDownloadReport = recordingId => (dispatch, getState) =>
  dispatch(fetchApi({
    url: `${getApiBaseUrl()}/i/v1/idtf/connections/mct/recordings/${recordingId}.pdf`,
    authType: AUTH_TYPES.BEARER,
    header: {
      Accept: 'application/pdf',
    },
    method: 'GET',
  }))
    .then(res => {
      if (res.status != 500) {
        return res.blob()
      } else {
        return res.json()
      }
    })
    .catch(err => {
      throw err
    })


export const updateUserSettings = settings => (dispatch, getState) =>
  dispatch(fetchApi({
    url: `${getApiBaseUrl()}/i/v1/update_settings`,
    authType: AUTH_TYPES.BEARER,
    method: 'POST',
    body: JSON.stringify(settings),
  }))
  // .then(res => res.json())
    .catch(err => {
      throw err
    })
// /i/v1/idtf/teams/:teamID/participants/:participantID/re-enroll
export const idtfPatientEnrollment = (teamId, data, isEdit, patientId) => (
  dispatch,
  getState,
) => {
  const URL = isEdit
    ? `${getApiBaseUrl()}/i/v1/idtf/teams/${teamId}/participants/${patientId}/re-enroll`
    : `${getApiBaseUrl()}/i/v1/idtf/teams/${teamId}/participants`
  return dispatch(
    fetchApi({
      url: URL,
      authType: AUTH_TYPES.BEARER,
      method: 'POST',
      body: JSON.stringify(data),
    }),
  ).catch(err => {
    throw err
  })
}

export const updateDuration = (idtfConnId, data) => (dispatch, getState) =>
  dispatch(
    fetchApi({
      url: `${getApiBaseUrl()}/i/v1/idtfConnections/${idtfConnId}/updateDeviceAndDuration`,
      authType: AUTH_TYPES.BEARER,
      method: 'PUT',
      body: JSON.stringify(data),
    }),
  )
    .then(res => res.json())
    .catch(err => {
      throw err
    })

export const searchEnrolledPatients = (teamId, data) => (dispatch, getState) =>
  dispatch(
    fetchApi({
      url: `${getApiBaseUrl()}/i/v1/teams/${teamId}/searchParticipant?last_name=${
        data.lastName
      }&dob=${data.dob}&first_name=${data.firstName}&mrn=${data.mrn}&ssn=${
        data.ssn
      }&middle_name=${data.middleName}&ssn_last_four_digit=${data.ssnLastFour}`,
      authType: AUTH_TYPES.BEARER,
    }),
  )
    .then(res => res.json())
    .catch(err => {
      throw err
    })

// EOS Live update API Calls
export const fetchEOSHtml = EOSJson => (dispatch, getState,) =>
  dispatch(fetchApi({
    // url: `http://localhost:8001/pdf/eos/live-update`,
    url: 'http://localhost:8001/pdfs/eos/',
    authType: AUTH_TYPES.BEARER,
    method: 'GET',
    // body: JSON.stringify(EOSJson),
  }),).catch(err => {
    throw err
  })

export const fetchEOSHtmlReverseProxy = (data, eos_id) => (dispatch, getState,) =>
  dispatch(fetchApi({
    url: `${getApiBaseUrl()}/i/v1/idtf/connections/${eos_id}/eosReport/live-update`,
    authType: AUTH_TYPES.BEARER,
    method: 'POST',
    body: JSON.stringify(data),
  }),).catch(err => {
    throw err
  })

export const getEOSJsonData = eos_id => (dispatch, getState) =>
  dispatch(fetchApi({
    url: `${getApiBaseUrl()}/i/v1/idtfConnections/${eos_id}/eosReportJSON`,
    authType: AUTH_TYPES.BEARER,
    method: 'GET',
  }))
    .then(res => res.json())
    .catch(err => {
      throw err
    })

export const idtfPatientRevoke = idtfConnectionId => (dispatch, getState) =>
  dispatch(
    fetchApi({
      url: `${getApiBaseUrl()}/i/v1/idtf/connections/${idtfConnectionId}/revoke`,
      authType: AUTH_TYPES.BEARER,
      method: 'PUT',
    }),
  )
    .then(res => res.json())
    .catch(err => {
      throw err
    })

export const esignEOSPdfs = (data, eos_id) => (dispatch, getState,) =>
  dispatch(fetchApi({
    url: `${getApiBaseUrl()}/i/v1/idtf/connections/${eos_id}/signEosReport`,
    authType: AUTH_TYPES.BEARER,
    method: 'PUT',
    body: JSON.stringify(data),
  }),).catch(err => {
    throw err
  })
export const getEosEventsHistory = idtfConnId => (dispatch, getState) =>
  dispatch(fetchApi({
    url: `${getApiBaseUrl()}/i/v1/idtf/connections/${idtfConnId}/eosEventsHistory`,
    authType: AUTH_TYPES.BEARER,
  }))
    .then(res => res.json())
    .catch(err => {
      throw err
    })

export const idtfPatientEarlyTermination = idtfConnectionId => (
  dispatch,
  getState,
) =>
  dispatch(
    fetchApi({
      url: `${getApiBaseUrl()}/i/v1/idtf/connections/${idtfConnectionId}/earlyTermination`,
      authType: AUTH_TYPES.BEARER,
      method: 'PUT',
    }),
  )
    .then(res => res.json())
    .catch(err => {
      throw err
    })

export const techCompletedEosReview = (idtfConnId, completedEosReview) => (dispatch, getState) =>
  dispatch(fetchApi({
    url: `${getApiBaseUrl()}/i/v1/idtf/connections/${idtfConnId}/techCompletedEosReview`,
    authType: AUTH_TYPES.BEARER,
    method: 'PUT',
    body: JSON.stringify(completedEosReview),
  }))
    .then(res => res.json())
    .catch(err => {
      throw err
    })

export const fetchCoveredStates = memberId => (dispatch, getState) =>
  dispatch(
    fetchApi({
      url: `${getApiBaseUrl()}/i/v1/members/${memberId}/states`,
      authType: AUTH_TYPES.BEARER,
      method: 'GET',
    }),
  )
    .then(res => res.json())
    .catch(err => {
      throw err
    })

export const fetchLicenseTable = memberId => (dispatch, getState) =>
  dispatch(
    fetchApi({
      url: `${getApiBaseUrl()}/i/v1/members/${memberId}/license`,
      authType: AUTH_TYPES.BEARER,
      method: 'GET',
    }),
  )
    .then(res => res.json())
    .catch(err => {
      throw err
    })

export const postAddLicense = (memberId, data) => (
  dispatch,
  getState,
) =>
  dispatch(
    fetchApi({
      url: `${getApiBaseUrl()}/i/v1/members/${memberId}/license`,
      authType: AUTH_TYPES.BEARER,
      method: 'POST',
      body: JSON.stringify(data),
    }),
  ).catch(err => {
    throw err
  })
export const fetchDeleteLicense = (memberId, member_license_id) => (
  dispatch,
  getState,
) =>
  dispatch(
    fetchApi({
      url: `${getApiBaseUrl()}/i/v1/members/${memberId}/license/${member_license_id}`,
      authType: AUTH_TYPES.BEARER,
      method: 'DELETE',
    }),
  )
    .then(res => res.json())
    .catch(err => {
      throw err
    })

export const fetchInventory = teamId => (dispatch, getState) => {
  const fetchConfig = {
    url: `${getApiBaseUrl()}/i/v1/teams/${teamId}/connectionInventory`,
    authType: AUTH_TYPES.BEARER,
  }
  return dispatch(fetchApi(fetchConfig)).then(res => res.json()).catch(err => { throw err })
}

export const postEditLicense = (member_id, data) => (
  dispatch,
  getState,
) =>
  dispatch(
    fetchApi({
      url: `${getApiBaseUrl()}/i/v1/members/${member_id}/license`,
      authType: AUTH_TYPES.BEARER,
      method: 'PUT',
      body: JSON.stringify(data),
    }),
  )
    .then(res => res.json())
    .catch(err => {
      throw err
    })
export const fetchDeactivateAccount = (member_id, data) => (
  dispatch,
  getState,
) =>
  dispatch(
    fetchApi({
      url: `${getApiBaseUrl()}/i/v1/members/${member_id}/deactivate`,
      authType: AUTH_TYPES.BEARER,
      method: 'POST',
      body: JSON.stringify(data),
    }),
  )
    .then(res => res.json())
    .catch(err => {
      throw err
    })

export const getConnectionInfo = participantId => (dispatch, getState) =>
  dispatch(fetchApi({
    url: `${getApiBaseUrl()}/i/v1/participants/${participantId}/latestConnection`,
    authType: AUTH_TYPES.BEARER,
    method: 'GET',
  }))
    .then(res => res.json())
    .catch(err => {
      throw err
    })

export const fetchResendTeamMemberInvite = (teamId, inviteId) => (dispatch, getState) =>
  dispatch(fetchApi({
    url: `${getApiBaseUrl()}/i/v1/teams/${teamId}/reSendInvites`,
    authType: AUTH_TYPES.BEARER,
    method: 'POST',
    body: JSON.stringify({ team_id: teamId, Invite_ids: [ inviteId ] }),
  }))
    // .then(res => res.json())
    .catch(err => {
      throw err
    })



// WEBPACK FOOTER //
// ./src/legacy/containers/ApiUrls/ApiUrls.js